import React from "react";
import {
  nutriLookup,
  NutriValues,
  NutriValuesWithoutKcal,
} from "../data/nutriValues";
import { computeCalories } from "../utils/caloriesUtil";
import { round } from "mathjs";

interface NutriBarProps {
  nutriValues: NutriValuesWithoutKcal | undefined;
}

export const NutriBar = (props: NutriBarProps) => {
  if (props.nutriValues == undefined) {
    return <></>;
  }
  const fatColor = nutriLookup["fat"].color;
  const carbsColor = nutriLookup["carbs"].color;
  const proteinColor = nutriLookup["protein"].color;
  const computedKcal = computeCalories(props.nutriValues);
  const breakpoint1 = ((props.nutriValues.fat * 9) / computedKcal) * 100;
  const breakpoint2 =
    ((props.nutriValues.carbs * 4) / computedKcal) * 100 + breakpoint1;

  return (
    <div
      className="h-2.5 w-full"
      style={{
        backgroundImage: `linear-gradient(to right, ${fatColor} 0%, ${fatColor} ${breakpoint1}%, ${carbsColor} ${breakpoint1}%, ${carbsColor} ${breakpoint2}%, ${proteinColor} ${breakpoint2}%, ${proteinColor} 100% )`,
      }}
    />
  );
};

interface NutriBulletProps {
  nutriValues: NutriValuesWithoutKcal | undefined;
  factor: number | undefined;
}

export const NutriBullets = (props: NutriBulletProps) => {
  if (
    props.nutriValues == undefined ||
    props.factor == undefined ||
    props.factor == 0
  ) {
    return <></>;
  }
  const carbsValue = round((props.nutriValues.carbs / 100) * props.factor, 2);
  const fatValue = round((props.nutriValues.fat / 100) * props.factor, 2);
  const proteinValue = round(
    (props.nutriValues.protein / 100) * props.factor,
    2,
  );
  return (
    <div className="flex w-full flex-wrap items-center gap-2">
      <span
        className="h-[7px] w-[7px] shrink-0 rounded-full"
        style={{ backgroundColor: nutriLookup["fat"].color }}
      />
      <span className="text-xs text-ink">
        {nutriLookup["fat"].shortName}: {fatValue}g
      </span>
      <span
        className="h-[7px] w-[7px] shrink-0 rounded-full"
        style={{ backgroundColor: nutriLookup["carbs"].color }}
      />
      <span className="text-xs text-ink">
        {nutriLookup["carbs"].shortName}: {carbsValue}g
      </span>
      <span
        className="h-[7px] w-[7px] shrink-0 rounded-full"
        style={{ backgroundColor: nutriLookup["protein"].color }}
      />
      <span className="text-xs text-ink">
        {nutriLookup["protein"].shortName}: {proteinValue}g
      </span>
    </div>
  );
};

export function KcalFormLabel(props: { kcal: number }) {
  return (
    <span className="text-xs text-ink">
      Kalorien: {round(props.kcal, 0)} kcal
    </span>
  );
}

export function NutriBarWithKcalAndBullets(props: {
  nutriValues: NutriValues;
  factor: number;
}) {
  return (
    <>
      <KcalFormLabel kcal={props.nutriValues.kcal} />
      <NutriBar
        nutriValues={{
          fat: props.nutriValues.fat,
          carbs: props.nutriValues.carbs,
          protein: props.nutriValues.protein,
        }}
      />
      <NutriBullets
        nutriValues={{
          fat: props.nutriValues.fat,
          carbs: props.nutriValues.carbs,
          protein: props.nutriValues.protein,
        }}
        factor={props.factor}
      />
    </>
  );
}
